import React from 'react';
import { contactData } from '../data/siteContent';
import { Mail } from 'lucide-react';

const Contact = () => {
  return (
    <section className="relative py-20 bg-black">
      {/* DJ NEFF Logo Watermark */}
      <div className="absolute inset-0 opacity-5 pointer-events-none overflow-hidden">
        <div className="flex flex-col h-full justify-around">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="flex justify-around whitespace-nowrap">
              {[...Array(4)].map((_, j) => (
                <img
                  key={j}
                  src="https://customer-assets.emergentagent.com/job_professional-epk/artifacts/k20ff6ft_IMG_4353_2-removebg-preview.png"
                  alt=""
                  className="w-32 h-32 md:w-40 md:h-40 object-contain"
                />
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <h2 className="text-5xl md:text-6xl font-black text-white mb-12 text-center">
          CONTACTS
        </h2>

        <div className="flex justify-center max-w-5xl mx-auto">
          <div className="group flex flex-col items-center gap-4 p-8 border-2 border-white bg-transparent hover:bg-white transition-all duration-300">
            <Mail className="w-12 h-12 text-white group-hover:text-black transition-colors duration-300" />
            <div className="text-center">
              <p className="text-white group-hover:text-black font-black text-xl mb-2 transition-colors duration-300">
                EMAIL
              </p>
              <a
                href={`mailto:${contactData.email}`}
                className="text-gray-300 group-hover:text-gray-700 text-sm hover:underline transition-colors duration-300"
              >
                {contactData.email}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;